import { Field, InjectedFormProps, reduxForm } from "redux-form"
import { IStyledFieldProps } from "../../../../parts/styled-field/styled-input-field"
import { ICheckboxProps } from "../auth-agreement-check"
import { formData, formId } from "./form-meta"
import { validate } from "./validation"
import React from "react"
import { AuthSendButton } from "../auth-send-button"

const Component = (props: InjectedFormProps) => {
  const { handleSubmit, submitting } = props
  return (
    <form onSubmit={handleSubmit}>
      {formData.map((data, i) => (
        <Field<IStyledFieldProps | ICheckboxProps> key={i} {...data} />
      ))}
      <AuthSendButton
        isSending={submitting}
        text={"SNS連携登録する"}
        sendingText={"SNS連携登録中です"}
        onClick={handleSubmit}
      />
    </form>
  )
}

export const Form = reduxForm({
  form: formId,
  validate,
  enableReinitialize: true,
})(Component)
